export default "__VITE_ASSET__DXFl8hea__"